import { Button, Td, Tr } from '@chakra-ui/react'
import React, { Suspense, memo } from 'react'
import { Aprovar } from './Aprovar'
import { api } from '../../../services/api'
import { useMutation } from 'react-query'
const Descricao = React.lazy(() =>
  import('./Descricao').then(({ Descricao }) => ({ default: Descricao }))
)

async function aprovar({ id, aprovacao }) {
  const response = await api.post(
    '/site/v2/pedido/autoriza-desconto-funcionario',
    {
      id_usuario: id,
      aprovacao: aprovacao,
    }
  )

  console.log(response.data)

  return response.data
}

export function AcompanhamentoItemComponent({ item, refresh }) {

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: async ({ id, aprovacao }) => aprovar({ id, aprovacao }),
    onSuccess: () => {
      console.log('sucesso')
      refresh()
    },
    onError: () => {
      console.log('erro')
    },
  })
  

  if (!item) return null


  return (
    <Tr key={item.id_usuario}>
      <Td>{item.data}</Td>
      <Td>{item.numero_pedido}</Td>
      <Td textTransform="capitalize">{item.funcionario}</Td>
      <Td textAlign="center">{item.codigo_produto}</Td>
      <Td textTransform="capitalize">{item.produto}</Td>
      <Td textAlign="center">{item.referencia}</Td>
      <Td textAlign="center">{item.quantidade}</Td>
      <Td textAlign="center">
        <Suspense fallback={<div>Carregando...</div>}>
          <Descricao descricao={item.originalObservacao} />
        </Suspense>
      </Td>
      <Td>{item.valor_desconto}</Td>
      <Td textAlign="center">
        <Button 
          colorScheme="green" 
          onClick={() => {
            mutateAsync({ id: item.id_usuario, aprovacao: "S"})
          }}
        >
          Aprovar
        </Button>
        <Button 
          colorScheme="red"
          ml={2}
          onClick={() => {
            mutateAsync({ id: item.id_usuario, aprovacao: "N"})
          }}
        >
          Reprovar
        </Button>
      </Td>
    </Tr>
  )
}

export const AcompanhamentoItem = memo(
  AcompanhamentoItemComponent,
  (prevProps, nextProps) => prevProps.item === nextProps.item
)
